<template>
    <draggable class="dragArea"
               ghost-class="ghost"
               handle=".handle"
               tag="ul"
               item-key="id"
               :list="categoriesCurrentDepthLevel()"
               @change="handleChange"
               :group="{ name: 'g1' }"
               :parentid = "parentid"
               :sort="true"
               :selectedItems="selectedItems">

        <template v-for="( element, index ) in categories">
            <li class="list-group-item">
                <span class="handle" v-if="element.id != null">
                    <span class="bi bi-view-stacked" />
                </span>
                <TreeItem
                    @deleteCategory="deleteCategory"
                    @addChildCategory="addChildCategory"
                    @saveChildCategory="saveChildCategory"
                    @toggleChildren="handleSelection"
                    :element="element"
                    :showChildren="showChildren(element)"
                    :hasChildren="hasChildren(element)"
                    @updateCategory="updateCategory"/>

                <nested-draggable
                    v-if="dragAreaIsVisible(element) && element.id != null"
                    :selectedItems="selectedItems"
                    @updateSorting="updateSorting"
                    @updateCategory="updateCategory"
                    @toggleChildren="handleSelection"
                    @deleteCategory="deleteCategory"
                    @addChildCategory="addChildCategory"
                    @saveChildCategory="saveChildCategory"
                    :parentid="element.id"
                    :categories="categories"/>
            </li>
        </template>
    </draggable>
</template>
<script>
    import draggable from "vuedraggable";
    import TreeItem from "./TreeItem";

    export default {
        props: {
            categories: {
                required: true,
                type: Array
            },
            parentid: {},
            selectedItems: {
                required: true,
                type: Array
            }
        },
        data() {
            return {

            }
        },
        components: {
            draggable,
            TreeItem

        },
        name: "nested-draggable",
        methods: {
            hasChildren(category) {
                if (this.subLevel(this.categories, category.id).length > 0) {
                    return true;
                }
                return false;
            },

            categoriesCurrentDepthLevel() {
                return this.subLevel(this.categories, this.parentid).sort((a, b) => a.sort_order - b.sort_order);
            },

            subLevel(categories, parentid) {
                return categories.filter(category => category.parent_id === parentid);
            },

            updateCategory(category) {
                this.$emit('updateCategory', category)
            },

            handleSelection(category) {
                this.$emit('toggleChildren', category)
            },

            addChildCategory(category) {
                this.$emit('addChildCategory', category)
            },
            saveChildCategory(category) {
                this.$emit('saveChildCategory', category)
            },
            deleteCategory(category) {
                this.$emit('deleteCategory', category)
            },
            updateSorting(category, direction) {
                this.$emit('updateSorting', category, direction)
            },

            showChildren(selectedcategory) {
                for (let selectedItem of this.selectedItems) {
                    if (selectedItem.id === selectedcategory.id) {
                        return true;
                    }
                }
                return false;
            },

            dragAreaIsVisible(selectedcategory) {
                if (!this.showChildren(selectedcategory) && !this.hasChildren(selectedcategory)) {
                    if (selectedcategory.parent_id == null) {
                        return true;
                    }
                    for (let selectedItem of this.selectedItems) {
                        if (selectedItem.id === selectedcategory.parent_id) {
                            return true;
                        }
                    }
                }
                return this.showChildren(selectedcategory);
            },

            handleChange(e) {
                let moveUp = true;
                if (e.added != null) {
                    let category = e.added.element;
                    category.parent_id = this.parentid;
                    category.sort_order = e.added.newIndex;

                    axios
                            .put('/categories/' + e.added.element.id + '/edit', category)
                            .then(response => (this.$emit('updateSorting', response.data, moveUp)))
                            .catch(error => {
                                console.log(error)
                            })



                } else if (e.moved != null) {

                    if (e.moved.newIndex > e.moved.oldIndex) {
                        moveUp = false;
                    }
                    let category = e.moved.element;
                    category.sort_order = e.moved.newIndex;
                    this.$emit('updateSorting', category, moveUp)

                }
            },
        }
    };

</script>
<style scoped>
    .dragArea {
        /*background: #eee;*/
        min-height: 40px;
        /*outline: 1px dashed;*/
    }

    .ghost {
        height: 40px;
        background: #eee;
    }
    .handle {
        float: left;
        padding-bottom: 8px;
        margin-right: 8px;
    }
</style>
